import { Message } from "../message.model";

export interface FechaPeriodoAnteriorFlowByZone {
  fecha_inicial: string;
  fecha_final: string;
}

export type BodyFlowByZone =
  | {
      Tipo_consulta_BD: 'RANGO_MESES';
      mes_inicial: string;
      mes_final: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnteriorFlowByZone;
    }
  | {
      Tipo_consulta_BD: 'RANGO_DIAS';
      fecha_inicial: string;
      fecha_final: string;
      sector: string;
      sucursal: string;
      por_defecto?: string;
      fecha_periodo_anterior?: FechaPeriodoAnteriorFlowByZone;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ACTUAL';
      anio_actual: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnteriorFlowByZone;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ANTERIOR';
      anio_anterior: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnteriorFlowByZone;
    }
  | {
      Tipo_consulta_BD: 'MES_ACTUAL';
      mes_actual: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnteriorFlowByZone;
    }
  | {
      Tipo_consulta_BD: 'MES_ANTERIOR';
      mes_anterior: string;
      sector: string;
      sucursal: string;
      fecha_periodo_anterior?: FechaPeriodoAnteriorFlowByZone;
    };

export interface ResponseFlowByZone {
  column_name: ColumnNameFlowByZone | Message;
}

export interface ColumnNameFlowByZone {
  "public data": DataFlowByZone;
}

export interface DataFlowByZone {
  anio_base:     number;
  anio_anterior: number | string;
  accesos:       ZoneFlow[];
  resumen:       SummaryFlowByZone;
}

// El back conserva el nombre 'Acceso' para la zona, por eso las gráficas siguen usando esa clave
export interface ZoneFlow {
  Acceso:                  string;
  Flujo:                   number;
  Flujo_periodo_anterior?: number;
}

export interface SummaryFlowByZone {
  total_flujo:          number;
  total_flujo_anterior: number;
  diferencia:           number;
  porcentaje:           string;
  indicador:            string;
}
